import xss from 'xss'
import { getMainHost } from '../config'

function getJsonFromUrl() {
    var query = location.search.substr(1);
    var result = {};
    query.split("&").forEach(function (part) {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
}

function splitUrl(url) {
    let query = url.split('?')[1];

    let result = {};
    query.split('&').forEach(function (part) {
        let item = part.split('=');
        result[item[0]] = decodeURIComponent(item[1]);
    })
    return result;
}

function printObject(obj) {
    let result = '';
    for (let i in obj) {
        result = result + i + '=' + obj[i] + '&';
    }
    return result;
}

function filterDiscuss(discussText) {
    let filters = [/听不到/, /听不见/, /没有声音/, /没声音/, /听不了/, /没声/];
    let noListen = false;
    filters.map((item) => {
        if (item.test(discussText)) {
            noListen = true;
        }
        return null
    });
    return noListen;
}

function setToken(token) {
    localStorage.setItem('_token', token)
    return token
}

function getToken() {
    var token = localStorage.getItem('_token') || ''
    return token
}

function getAccessToken() {
    var access_token = localStorage.getItem('wk_access_token') || ''
    return access_token
}

function setAccessToken(access_token) {
    localStorage.setItem('wk_access_token', access_token)
    return access_token
}

function clearToken() {
    localStorage.removeItem('_token')
}

function removeAds(content) {
    if (content.indexOf('微信') > -1 || content.indexOf('手机') > -1) {
        content = content.replace(/[a-z0-9_-]+/gi, function (s) {
            return new Array(s.length).join('*');
        });
    }
    // 过滤手机号码
    content = content.replace(/1[3,4,5,7,8]{1}[0-9]{9}/gi, function (s) {
        return new Array(s.length).join('*');
    });
    return content;
}

function toTime(ts) {
    const second = ts % 60;
    const minute = ts / 60;
    let secondStr = Math.floor(second).toString();
    if (secondStr.length === 1)
        secondStr = '0' + secondStr;
    let minuteStr = Math.floor(minute).toString();
    if (minuteStr.length === 1)
        minuteStr = '0' + minuteStr;
    return minuteStr + ':' + secondStr;
}

function drawAudioWave(element, points) {
    let canvas = element;
    if (!canvas.getContext) {
        return;
    }
    let ps = [];
    let A = 1;
    let C = 1;
    let Y = Math.pow(2500, A);
    let sum = 0;
    for (let i = 0; i < points.length; i++)
        sum += points[i];
    let average = sum / points.length;
    for (let i = 0; i < points.length; i++) {
        let x = Math.pow(points[i], A);
        if (average > 1250) {
            x /= 1.2;
        }
        ps.push(x);
    }
    points = ps;
    let ctx = canvas.getContext('2d');
    ctx.lineWidth = 4.5 * C;
    ctx.strokeStyle = 'rgb(99, 207, 48)';
    let w = 7 * C;
    let px = 115;
    for (let i = 0; i < points.length; i++) {
        let ch = Math.max(14, points[i] * 100000 / Y);
        ctx.beginPath();
        let py = 340 / 2 - ch / 2;
        ctx.moveTo(px + i * w, py);
        ctx.lineTo(px + i * w, py + ch);
        ctx.stroke();
    }
}

function renderMoney(money) {
    return (money / 100.0).toFixed(2)
}

function renderNewMoney(money) {
    return (money / 100.0).toFixed(2).split('.')
}

//去掉红包money后面的小数点
function renderMoneyHideDecimal(money) {
    return Math.round(money / 100)
}

function getTimestamp(timestampDelta) {
    return (Date.now() * 1000 + timestampDelta * 1000000) / 1000000;
}

// 只保留二位小数点
function toDecimal2(x) {
    var f = parseFloat(x);
    if (isNaN(f)) {
        return false;
    }
    var f = Math.round(x*100)/100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    return s;
}

function isPC() {
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        return false
    } else {
        return true;
    }
}

//课程时间流--计算距今几天后（至少需要大于一天）
function renderLectureTimeStream(timestamp) {
    return Math.floor(((timestamp * 1000) - Date.parse(new Date())) / 1000 / 3600 / 24) + '天后'
}

//用法--TimeStream(1500614243, 'CN-YMD')
function TimeStream(timestamp, type) {
    let date = new Date(timestamp * 1000);
    let Y = date.getFullYear();
    let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    switch (type) {
        case 'YMD': //年-月-日
            return Y + '-' + M + '-' + D;
        case 'MD': //月-日
            return M + '-' + D;
        case 'MD_HM': //月-日
            return M + '-' + D + ' ' + h + ':' + m;
        case 'YMD_HMS': // 月-日 时：分：秒
            return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s;
        case 'CN_YMD': //x年x月x日
            return Y + '年' + M + '月' + D + '日';
        case 'CN_YMD_HM': //x年x月x日
            return Y + '年' + M + '月' + D + '日' + ' ' + h + ':' + m;
        case 'CN_MD_HM': //x月x日
            return M + '月' + D + '日' + ' ' + h + ':' + m;
        case 'hm': // 时:分
            return h + ':' + m;
        case '-D': //天数差
            return Math.floor(((timestamp * 1000) - Date.parse(new Date())) / 1000 / 3600 / 24);
        case '-H': //小时差
            return Math.ceil((timestamp * 1000 - Date.parse(new Date())) / 1000 / 3600);
        default: //年-月-日 时:分
            return Y + '-' + M + '-' + D + ' ' + h + ':' + m;
    }
}

// getHumanTime()(1500000000)
// => 今天 11:11；昨天 11:11；前天 11:11；星期六 11:11
function getHumanTime(time) {
    const offsetDays = ['今天', '昨天', '前天']
    const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    if (+time && String(time).length !== 13) {
        time *= 1000
    } else {
        time = Date.parse(time)
    }
    const ONE_DAY_STAMP = 86400000
    const nowDate = new Date()
    const somedayDate = new Date(time)
    const nowStamp = nowDate.getTime()
    const somedayStamp = somedayDate.getTime()
    const ms = TimeStream(somedayStamp / 1000, 'hm')
    const nowYMDStamp = Date.parse(TimeStream(nowStamp / 1000, 'YMD'))
    const somedayYMDStamp = Date.parse(TimeStream(somedayStamp / 1000, 'YMD'))
    const offsetYMDStamp = nowYMDStamp - somedayYMDStamp

    if (offsetYMDStamp < 0) {
        return TimeStream(time / 1000)
    }
    if (offsetYMDStamp === 0) {
        return `${offsetDays[0]} ${ms}`
    }
    if (offsetYMDStamp === ONE_DAY_STAMP) {
        return `${offsetDays[1]} ${ms}`
    }
    if (offsetYMDStamp === ONE_DAY_STAMP * 2) {
        return `${offsetDays[2]} ${ms}`
    }
    if ((offsetYMDStamp <= ONE_DAY_STAMP * 6) && (offsetYMDStamp > ONE_DAY_STAMP * 2)) {
        return `${weekDays[somedayDate.getDay()]} ${ms}`
    }
    return TimeStream(time / 1000)
}

function generateKey() {
    let date = new Date();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    return 'doublePlan-' + month + day;
}


function showBigAvatar(avatar_url, images) {
    const url = avatar_url.split('-avatar')[0]
    if (window.wxReady) {
        window.wx.previewImage({
            current: url, // 当前显示图片的http链接
            urls: images || [url] // 需要预览的图片http链接列表
        });
    } else {
        window.open(url)
    }
}

//判断是否是荔枝微课APP打开--用于webview
function isLZWKAPP() {
    if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())) {
        return true
    } else {
        return false
    }
}

export function isLHAPP() {
  return /lihua/.test(navigator.userAgent.toLocaleLowerCase())
}


function isLZWKAPPIpad() {
    /*iOS13系统ipad在app访问web，ua为Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko)
    该ua在web，需要被定义为iOS App*/
    /*注意：如果是iOS13系统ipad在浏览器访问web，ua为Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) 
    AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.3 Safari/605.1.15，这种依然是h5，不能被判定为App*/
    const userAgent = navigator.userAgent.toLocaleLowerCase()
    const reg = /mozilla\/5.0 \(macintosh; intel mac os x [0-9][0-9]_[0-9][0-9]\) applewebkit\/605.1.15 \(khtml, like gecko\)$/
    if (reg.test(userAgent)){
        return true
    }else {
        return false
    }
}

function shouldLinkToAPP() {
    let toAPP = isLZWKAPP() && ((window.systemType === 'ios' && judgeAPPVersion(370)) || (window.systemType === 'android' && judgeAPPVersion(262)))

    return toAPP || isLZWKAPPIpad()
}

//判断APP版本号--用于webview
function judgeAPPVersion(num) {
    let userAgent = navigator.userAgent.toLowerCase();
    let version = userAgent.match(/lycheer\/(\d)+.(\d)+.(\d)/);
    let versionNumber = version ? parseInt(version[0].replace('lycheer/', '').replace(/\./g, "")) : '';
    return versionNumber >= num;
}

function getSdkVersion() {
    const versionMatch = navigator.userAgent.toLowerCase().match(/sdkversion\/(\d+)/)
    return versionMatch ? +versionMatch[1] : 0
}

export function isLihuaApp() {
    return /lihua/.test(navigator.userAgent.toLowerCase())
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function banRightClick(dom) {
    dom.oncontextmenu = function() {return false;}
}

function formatNumberMoney(num) {
    let sign,cents = null
    if (!num)
        return "0.00";
    num = num.toString().replace(/\$|\,/g, '');//去除$符号
    if (isNaN(num))
        num = "0.00";
    sign = (num == (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    cents = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10)
        cents = "0" + cents;
    for ( var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + ','+ num.substring(num.length - (4 * i + 3));
    return (((sign) ? '' : '-') + '' + num + '.' + cents);
}

// 可存取object
const storage = {
    getItem(key) {
        let value = window.localStorage.getItem(key)
        try {
            value = JSON.parse(value)
        } catch (e) {
            
        } finally {

        }
        return value
    },
    setItem(key, value) {
        if (typeof value === 'object') {
            value = JSON.stringify(value)
        }
        window.localStorage.setItem(key, value)
    },
    removeItem (key) {
        window.localStorage.removeItem(key)
    }
}

function isMoney(money) {
    return /^(-)?(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/.test(money) && money > 0
}
function renderCouponMoney(money) {
    let newMoney = (money / 100.0).toFixed(2);
    let arr = newMoney.split('.');
    if (arr[1] === '00'){
        return arr[0]
    }else {
        return newMoney
    }
}

const isWeiXin = () => /MicroMessenger/.test(navigator.userAgent) && !/WindowsWechat/.test(navigator.userAgent)

// 兼容ios 11 微信6.5.21版本更新之后底部fix的问题
function isNewWeiXinMachine() {
    let userAgent = navigator.userAgent.toLowerCase();
    let originVersion = '6.5.21';
    let wxVersion = userAgent.match(/micromessenger\/(\d)+.(\d)+.(\d)+/);
    wxVersion = wxVersion ? wxVersion[0].replace('micromessenger/', '') : originVersion;
    let subRes = getMaxMachine(wxVersion, originVersion);

    if (userAgent.match(/cpu iphone os (.*?) like mac os/)) {
        let machineVersion = userAgent.match(/cpu iphone os (.*?) like mac os/)[1].split('_')[0];
        return machineVersion >= 11 && subRes >= 0 && window.systemType === 'ios'
    } else {
        return false
    }
}

function getMaxMachine(machine1, machine2) {
    let machineArr1 = machine1.split('.');
    let machineArr2 = machine2.split('.');

    let result = 0;
    for (let i = 0, len = machineArr1.length; i < len - 1; i ++) {
        result = (+machineArr1[i]) - (+machineArr2[i]);
        if (result !== 0) {
            break;
        }
    }
    return result;
}

function isQQ() {
    return / qq\//.test(navigator.userAgent.toLowerCase())
}

function isAlipay() {
    // return true
    return /alipay/.test(navigator.userAgent.toLowerCase())
}

//判断到没有上一页时，自动将首页设为上一页
function AddRef() {
    let params = getJsonFromUrl()

    let referrer = document.referrer;
    let shouldAddRef = referrer === '' && window.location.pathname !== '/' && !isLZWKAPP() /*&& history && history.length <= 1*/

    if (params && params.isMinaApp) {
        shouldAddRef = false
    }

    // 蒲公英商城过来的链接
    if (/pgy/.test(window.location.search)) {
        shouldAddRef = false
    }

    if (shouldAddRef && !/timeline/.test(window.location.search)){
        let real_url = window.location.href;
        let query = {from: 'pushstate'};
        history.replaceState(query, '十方教育', '/specials/newindexpage/?from=outside_site');
        history.pushState(null, '十方教育', real_url);
        window.addEventListener("popstate", function(e) {
            window.MtaH5 && window.MtaH5.clickStat('to_index_fr_onepage');
        }, false);
    }
}

//双字节替换成两个单字节然后返回字符串长度
function GetRealLength(string) {
    if (string === ''){
        return 0
    }
    if (typeof string !== "string"){
        string += "";
    }
    return string.replace(/[^\x00-\xff]/g,"01").length;
}

// randomArr([1,2,3,4]) => [3,1,2,4]
function randomArr(arr) {
    arr = arr.slice()
    let retArr = []
    const staticArrLen = arr.length
    let arrLength = staticArrLen
    let randNum
    for (let i = 0; i < staticArrLen; i ++) {
      randNum = random(0, arrLength)
      retArr.push(arr[randNum])
      arr.splice(randNum, 1)
      arrLength --
    }
    return retArr
  }

// min <= x < max
// random(0, 10) => 4
function random(min, max) {
    return Math.floor(Math.random() * (max - min) + min)
}

// 解决返回黑屏问题
function fixBackContentEmpty() {
    setTimeout(() => {
        window.scrollTo(0,1)
    }, 100)
}

function isAndroid() {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1
}

function isIos() {
    return navigator.userAgent.indexOf('iP') > -1
}

function isIphoneX(){
    return /iphone/gi.test(navigator.userAgent) && (screen.height === 812 && screen.width === 375)
}

// 35000 => 3.5万
function renderPopular(num) {
    if (num < 1e4) {
        return num
    } else {
        return `${+(num / 1e4).toFixed(2)}万`
    }
}

function filterHTML(htmlStr) {
    let options = {
        onIgnoreTagAttr(tag, name, value, isWhiteAttr) {
            if (name.substr(0, 2) !== "on") {
                return name + '="' + xss.escapeAttrValue(value) + '"'
            }
        },
        onTag(tag, html, options) {
            if (tag === 'style' || tag === 'iframe') {
                return html
            }
        },
        stripIgnoreTag: true,
        stripIgnoreTagBody: ["script"]
    }
    return xss(htmlStr, options)
}

function matchUrl(str) {
    let re = /((http|https):\/\/([\w\-]+\.)+[\w\-]+(\/[\w\u4e00-\u9fa5\-\.\/?\@\%\!\&=\+\~\:\#\;\,]*)?)/ig
    return str.match(re) && str.match(re)[0]
}

function isTouchBottom(distance) {
    let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    let scrollHeight = document.body.scrollHeight || document.documentElement.scrollHeight
    return scrollTop + document.documentElement.clientHeight + distance >= scrollHeight
}

function replaceAllmatching(matchVal, newValue, str) {
    // const reg = new RegExp(matchVal, 'g')
    // const newStr = str.replace(reg, newValue)
    // return newStr
    let newStr = str.replace(/img.weike.fm/g, 'img2.lizhiweike.com').replace(/m.weike.fm/g, getMainHost())
    return newStr
}

function replaceNewHost(str) {
    let newStr = str.replace(/img.weike.fm/g, 'img2.lizhiweike.com').replace(/m.weike.fm/g, getMainHost())
    return newStr
}

function divideNum(num) {
    return +num < 1000000
}

function urlQuerySet(url, name, value) {
    const [path, search] = url.split('?')
    const queryList = search
        ? search
            .split('&')
            .map(item => item.split('='))
        : []

    const hasName = queryList.filter(([n]) => n === name).length > 0
    const newSearch = queryList
        .concat(hasName ? [] : [[name, undefined]])
        .map(([n, v]) => n === name ? [n, encodeURIComponent(value)] : [n, v])
        .map((item) => item.join('='))
        .join('&')
    return [path, newSearch].join('?')
}

function urlQueryGet(url, name) {
    const [_, search] = url.split('?')
    const queryList = search
        ? search
            .split('&')
            .map(item => item.split('='))
        : []
    const [item] = queryList.filter(([n]) => n === name)
    return item ? decodeURIComponent(item[1]) : null
}

function isFromCPSLiveroom() {
    return (/is_promote_flag=true/.test(location.search))
}

//页面埋点 玄武+cnzz
export function setEvent(evt, params) {
    try {
      Window._czc &&
        window._czc.push([
          "_trackEvent",
          "common",
          "click",
          evt,
          1
        ]);
  
      window.TorDataService &&
        window.TorDataService.emitAction(evt, {
          ...params,
          source_page: sessionStorage.getItem('event_source_page') || ''
        });
    } catch(err) {}
  }
  

export {
    isFromCPSLiveroom,
    urlQuerySet,
    urlQueryGet,
    getJsonFromUrl,
    setToken,
    getToken,
    clearToken,
    removeAds,
    toTime,
    drawAudioWave,
    renderMoney,
    getTimestamp,
    renderMoneyHideDecimal,
    printObject,
    filterDiscuss,
    isPC,
    renderLectureTimeStream,
    TimeStream,
    generateKey,
    showBigAvatar,
    isLZWKAPP,
    isLZWKAPPIpad,
    shouldLinkToAPP,
    judgeAPPVersion,
    getHumanTime,
    isNumeric,
    banRightClick,
    storage,
    isMoney,
    getSdkVersion,
    renderCouponMoney,
    isNewWeiXinMachine,
    isQQ,
    isAlipay,
    AddRef,
    renderNewMoney,
    getMaxMachine,
    GetRealLength,
    randomArr,
    random,
    fixBackContentEmpty,
    isAndroid,
    isWeiXin,
    isIos,
    isIphoneX,
    renderPopular,
    filterHTML,
    matchUrl,
    isTouchBottom,
    divideNum,
    formatNumberMoney,
    splitUrl,
    replaceAllmatching,
    replaceNewHost,
    getAccessToken,
    setAccessToken,
    toDecimal2
}



// WEBPACK FOOTER //
// ./src/utils/index.js